import { atom } from "jotai";

import { eventSignUpModalStatusAtom } from "../../stores/eventSignUpModal";

export const closeEventSignUpModalAtom = atom(null, (get, set) => {
  set(eventSignUpModalStatusAtom, { isOpen: false, overrideStep: null });
});
